<sc-modal>
  <div class="flex justify-between mb-6">
    <h3 class="text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3 font-headline">
      {{ 'components.verificationModal.primaryTitle' | scTranslate | async }}
    </h3>
    <sc-button variant="icon" [padding]="false" (click)="close()">
      <sc-svg name="cross" size="w-8 h-8"></sc-svg>
    </sc-button>
  </div>
  <div class="font-semibold mb-1">
    {{ 'components.verificationModal.secondaryTitle' | scTranslate | async }}
  </div>
  @if (data?.verificationType === VerificationType.Email) {
    <p class="mb-6">
      {{
        'components.verificationModal.emailSubtitle'
          | scTranslate: { substitution: Substitutions.Email, subValue: user()?.email }
          | async
      }}
    </p>
    <p class="text-secondaryText mb-6">
      {{ 'components.verificationModal.emailInfo' | scTranslate | async }}.
    </p>
  }
  @if (data?.verificationType === VerificationType.Sms) {
    <p class="mb-6">
      {{
        'components.verificationModal.smsSubtitle'
          | scTranslate: { substitution: Substitutions.Phone, subValue: currentMsisdn() }
          | async
      }}
    </p>
  }
  <div class="mb-7">
    <sc-code-input
      [inputClass]="{
        'border-red-500 border-2': verificationStatus() === VerificationStatusType.Error,
        'border-green-500 border-2': verificationStatus() === VerificationStatusType.Success,
      }"
      (codeCompleted)="codeCompleted($event)"
    ></sc-code-input>
  </div>
  <sc-modal-footer>
    <sc-button
      variant="primary"
      [disabled]="code()?.length < 6 || isStatusPending()"
      (click)="verify()"
    >
      <span>{{ buttonTitleKey() | scTranslate | async }}</span>
    </sc-button>
  </sc-modal-footer>
</sc-modal>
